import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Dropdown as Dropdown$1 } from 'primereact/dropdown';
import { forwardRef, useRef, useImperativeHandle } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { getPlaceholder } from '../../_utils/get-placeholder.js';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';
import { useSelectOverflowBehavior } from '../../_utils/SelectOverflowBehavior.js';

function DropdownComponent(props, ref) {
  const {
      name,
      value,
      horizontal,
      labelClassName,
      onBlur: _,
      valueGetter: __,
      wrapperClassName: ___,
      errorClassName: ____,
      placeholder: _____,
      filter: ______,
      labelTooltip: _______,
      labelSuffix: ________,
      bulkMode,
      outlined
    } = props,
    restProps = __rest(props, ["name", "value", "horizontal", "labelClassName", "onBlur", "valueGetter", "wrapperClassName", "errorClassName", "placeholder", "filter", "labelTooltip", "labelSuffix", "bulkMode", "outlined"]);
  const innerRef = useRef(null);
  useImperativeHandle(ref, () => innerRef.current);
  const minLengthForFilter = 6;
  const placeholder = getPlaceholder(Object.assign(Object.assign({}, props), {
    isDropdown: true
  }));
  const formContext = useFormContext();
  const isControlled = typeof value !== 'undefined';
  const prefixIconTemplate = props.prefixIcon ? jsx("span", {
    className: "p-inputgroup-addon",
    children: props.prefixIcon
  }) : null;
  const {
    resolvedPanelClassName,
    itemTemplate,
    valueTemplate
  } = useSelectOverflowBehavior(restProps);
  const hasInvalidState = Boolean(props.errorMessage || props.invalid);
  const {
      className: restClassName
    } = restProps,
    restDropdownProps = __rest(restProps, ["className"]);
  const handleHideOnClear = e => {
    if (!e.value && props.showClear && innerRef.current) {
      innerRef.current.hide();
    }
  };
  if (isControlled || !formContext || !name) {
    const {
        wrapperClassName: _,
        valueGetter: __,
        labelClassName: ___,
        labelTooltip: ____,
        errorClassName: _____,
        panelClassName: _______,
        panelStyle: ________,
        labelSuffix: _________,
        className: customClassName
      } = props,
      dropdownProps = __rest(props, ["wrapperClassName", "valueGetter", "labelClassName", "labelTooltip", "errorClassName", "panelClassName", "panelStyle", "labelSuffix", "className"]);
    return jsx(InputWrapper, Object.assign({}, props, {
      wrapperClassName: clsx(props.wrapperClassName, outlined && 'input-wrapper--outlined'),
      children: jsxs("div", {
        className: "p-inputgroup flex-1",
        children: [prefixIconTemplate, jsx(Dropdown$1, Object.assign({
          className: clsx('flex grow', customClassName, hasInvalidState && 'p-invalid'),
          ref: innerRef,
          name: name,
          placeholder: placeholder,
          filter: restProps.options && restProps.options.length > minLengthForFilter,
          filterPlaceholder: "Search.."
        }, dropdownProps, {
          appendTo: document.body,
          panelClassName: resolvedPanelClassName,
          valueTemplate: valueTemplate,
          invalid: hasInvalidState,
          onChange: e => {
            handleHideOnClear(e);
            if (props.onChange) {
              props.onChange(e);
            }
          }
        }))]
      })
    }));
  }
  return jsx(Controller, {
    name: name,
    control: formContext.control,
    rules: {
      required: props.required && !bulkMode
    },
    render: _ref => {
      let {
        field,
        fieldState
      } = _ref;
      return jsx(InputWrapper, Object.assign({
        field: field,
        fieldState: fieldState,
        horizontal: horizontal,
        labelClassName: labelClassName,
        name: name
      }, props, {
        wrapperClassName: clsx(props.wrapperClassName, outlined && 'input-wrapper--outlined'),
        children: jsxs("div", {
          className: "p-inputgroup flex-1",
          children: [prefixIconTemplate, jsx(Dropdown$1, Object.assign({
            className: clsx('flex flex-grow-1', restClassName, (fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid) || props.invalid ? 'p-invalid' : null)
          }, restDropdownProps, field, {
            name: name,
            appendTo: document.body,
            filter: restProps.options && restProps.options.length > minLengthForFilter,
            filterPlaceholder: "Search..",
            panelClassName: resolvedPanelClassName,
            placeholder: placeholder,
            invalid: (fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid) || props.invalid,
            value: (field === null || field === void 0 ? void 0 : field.value) || (props === null || props === void 0 ? void 0 : props.value) || '',
            onChange: e => {
              handleHideOnClear(e);
              if (props.valueGetter) {
                field.onChange(props.valueGetter(e));
              } else {
                field.onChange(e);
              }
              if (props.onChange) {
                props.onChange(e);
              }
            },
            ref: innerRef,
            itemTemplate: itemTemplate,
            valueTemplate: valueTemplate
          }))]
        })
      }));
    }
  });
}
const Dropdown = /*#__PURE__*/forwardRef(DropdownComponent);

export { Dropdown };
